import { Preferences } from "@capacitor/preferences";

const CRASH_KEY = "ipm_last_crash";

export interface CrashReport {
  occurredAt: string;
  message: string;
  stack?: string;
  componentStack?: string;
  userAgent?: string;
}

export const saveCrashReport = async (report: CrashReport): Promise<void> => {
  try {
    await Preferences.set({
      key: CRASH_KEY,
      value: JSON.stringify(report)
    });
  } catch {
    // Best-effort only.
  }
};

export const loadCrashReport = async (): Promise<CrashReport | null> => {
  try {
    const result = await Preferences.get({ key: CRASH_KEY });
    if (!result.value) return null;
    const parsed = JSON.parse(result.value) as CrashReport;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
};

